export enum ERPType {
    Avelon = 'avelon',
    Odoo = 'odoo',
}
